import btoa from './btoa'; // https://en.wikipedia.org/wiki/Base64#URL_applications

export default (function (input) {
  return btoa(input).replace(/\+/g, '-').replace(/\//g, '_');
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/b2a/es/btoau.js
// module id = 955
// module chunks = 0